export const APP_ANALYTICS_HOST = 'app.bill-alps.ch';

export function isAppAnalyticsHost(hostname: string): boolean {
  return hostname === APP_ANALYTICS_HOST;
}
